export const ROUTES = {
  HOME: "/",
  FAQ: "/faq",
  DASHBOARD: "/dashboard",
  TOP_CURATOR_CHART: "/top-curator-chart",
  CALLBACK: "/callback",
  SUBMIT_A_SONG: "/submit-song",
  SUBMIT_A_PLAYLIST: "/add-playlist",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  CONFIRM_PLAYLIST: "/confirm-playlist",
  SUBMIT_A_SONG_1: "/submit-song-1",
  SUBMIT_A_SONG_PLAYLIST: "/submit-song-playlist",
  VISIT_PUBLIC_PAGE: "/submit-public-page/:ids",
  REFERRAL_PAGE: "/ref/:id",
  PAGE_NOT_FOUND: "/page-not-found",
  ACCOUNT: "/account-setting",
  BLOG: `https://pitchplaylists.com/blog/`,
  REVIEWS: "/reviews",
  CONTACT: "/contact-us",
  SITEMAP: "/sitemap",
  SETTINGS: "/settings",
  META_ADS_BUILDER: "/meta-ads-builder",
  META_ADS_SETUP_PUBLIC: "/meta-campaigns",
  META_NEW_COMPAING: "/meta-new-campaign",
  META_NEW_COMPAING_PUBLIC: "/create-meta-ads",
  MY_META_CAMPAIGN: "/my-meta-campaign",
  MY_META_CAMPAIGN_PUBLIC: "/campaigns-list",
  META_ADS_LOGIN: "/meta-ads-login",
  META_ADS_REFERRAL: "/meta-ads-referral/:identifier",
  META_PRIVACY_TERMS: "/meta-ads/terms-and-conditions",
  FEATURES: "#features",
  TOP_PLAYLISTS: "#top-playlists",
  PLAYLIST: "/add-playlist",
  TRACK :"/submit-track",
  ARTIST_BANNED: "/artist-banned",
  PROFILE_BANNED: "/profile-banned",
  VERIFY_EMAIL: "/verify-email",
  CURATOR_PUBLIC_PAGE: "/cur/:curatorId",
  CURATOR_SONG_INFO: "/cur/:curatorId/song-info",
  CURATOR_AI_CONFIRMATION: "/cur/:curatorId/ai-confirmation",
  CURATOR_AI_REJECTION: "/cur/:curatorId/ai-rejection",
  CURATOR_PLAYLIST_SELECT: "/cur/:curatorId/select-playlists"
};
